module.exports = __webpack_public_path__ + "img/lzd_lord_gor_rok_0.65bd2818.png";